import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { CalendarDays, ExternalLink, Eye, EyeOff, Pencil, Trash2, Users } from 'lucide-react';
import { ESTADO_CLASE, ESTADO_LABEL, bodasApi, mensajeError, urlBoda, urlCompartirBoda } from '../bodasUtils';
import { BotonCopiar, Panel, Vacio } from './comunes';

const Accion = ({ onClick, icon: Icon, children, testId, peligro = false }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${peligro ? 'text-red-700 hover:bg-red-50' : 'text-slate-700 hover:bg-slate-100'}`}>
    <Icon className="h-4 w-4" />{children}
  </button>
);

const FilaBoda = ({ b, invitados, gestiona, onEstado, onEliminar }) => {
  const navigate = useNavigate();
  const [confirmar, setConfirmar] = useState(false);
  const publicada = b.estado === 'publicada';
  return (
    <li className="flex flex-col gap-3 p-4 sm:p-5 lg:flex-row lg:items-center lg:justify-between" data-testid={`boda-fila-${b.slug}`}>
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="text-base font-semibold text-slate-800">{b.persona_a} &amp; {b.persona_b}</h3>
          <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${ESTADO_CLASE[b.estado]}`} data-testid={`boda-estado-${b.slug}`}>{ESTADO_LABEL[b.estado]}</span>
        </div>
        <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500">
          {b.fecha_texto && <span className="inline-flex items-center gap-1"><CalendarDays className="h-4 w-4" />{b.fecha_texto}</span>}
          <span className="inline-flex items-center gap-1" data-testid={`boda-invitados-${b.slug}`}><Users className="h-4 w-4" />{invitados || 0} {invitados === 1 ? 'invitado registrado' : 'invitados registrados'}</span>
          <span>{b.cliente_nombre ? `Puntos para: ${b.cliente_nombre}` : 'Sin cliente asociado (no suma puntos)'}</span>
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        {publicada && <BotonCopiar texto={urlCompartirBoda(b.slug)} testId={`boda-copiar-${b.slug}`} />}
        {publicada && <Accion icon={ExternalLink} onClick={() => window.open(urlBoda(b.slug), '_blank', 'noopener')} testId={`boda-abrir-${b.slug}`}>Abrir</Accion>}
        {gestiona && <Accion icon={Pencil} onClick={() => navigate(`/admin/bodas/${b.slug}/editar`)} testId={`boda-editar-${b.slug}`}>Editar</Accion>}
        {gestiona && <Accion icon={publicada ? EyeOff : Eye} onClick={() => onEstado(b.slug, publicada ? 'despublicada' : 'publicada')} testId={`boda-publicar-${b.slug}`}>{publicada ? 'Despublicar' : 'Publicar'}</Accion>}
        {gestiona && (confirmar
          ? <Accion icon={Trash2} peligro onClick={() => onEliminar(b.slug)} testId={`boda-confirmar-eliminar-${b.slug}`}>¿Eliminar? Confirmar</Accion>
          : <Accion icon={Trash2} peligro onClick={() => { setConfirmar(true); setTimeout(() => setConfirmar(false), 4000); }} testId={`boda-eliminar-${b.slug}`}>Eliminar</Accion>)}
      </div>
    </li>
  );
};

export default function ListaBodas({ gestiona }) {
  const [datos, setDatos] = useState({ bodas: [], invitados: {} });
  const [cargando, setCargando] = useState(true);

  const cargar = useCallback(() => {
    setCargando(true);
    bodasApi.listar().then(setDatos).catch(e => toast.error(mensajeError(e, 'No se pudieron cargar las bodas'))).finally(() => setCargando(false));
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const accion = async (fn, ok) => {
    try { await fn(); toast.success(ok); cargar(); } catch (e) { toast.error(mensajeError(e)); }
  };
  const onEstado = (slug, estado) => accion(() => bodasApi.estado(slug, estado), estado === 'publicada' ? 'Página publicada' : 'Página despublicada');
  const onEliminar = (slug) => accion(() => bodasApi.eliminar(slug), 'Boda eliminada');

  return (
    <Panel testId="bodas-lista">
      {cargando && !datos.bodas.length ? <Vacio>Cargando…</Vacio> : !datos.bodas.length ? (
        <Vacio testId="bodas-vacio">Aún no hay bodas. {gestiona ? 'Crea la primera con “Nueva boda”.' : ''}</Vacio>
      ) : (
        <ul className="divide-y divide-slate-100">
          {datos.bodas.map(b => <FilaBoda key={b.slug} b={b} invitados={datos.invitados[b.id]} gestiona={gestiona} onEstado={onEstado} onEliminar={onEliminar} />)}
        </ul>
      )}
    </Panel>
  );
}
